import { z } from "zod";
import { useTranslations } from "~/hooks/useTranslations";

export const useGetUnlockCodeSchema = () => {
  const t = useTranslations();

  return z.object({
    code: z.string().min(1, t.error_messages.no_unlock_code),
  });
};

export type GetUnlockCodeSchema = z.infer<
  ReturnType<typeof useGetUnlockCodeSchema>
>;
